'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/table/style/css');

var _table = require('antd/lib/table');

var _table2 = _interopRequireDefault(_table);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserList = _react2.default.createClass({
    displayName: 'UserList',

    propTypes: {
        users: _react.PropTypes.object.isRequired
    },
    render: function render() {
        var _this = this;

        var columns = [{
            title: '编号',
            key: 'id',
            dataIndex: 'id'
        }, {
            title: '头像',
            key: 'avatar',
            render: function render(text, record, index) {
                return _react2.default.createElement('img', { className: 'avatar', src: record.avatar, alt: '\u5BA2\u6237\u5934\u50CF' });
            }
        }, {
            title: '名称',
            key: 'name',
            dataIndex: 'name'
        }, {
            title: '手机号',
            key: 'mobile',
            dataIndex: 'mobile'
        }, {
            title: '邮箱',
            key: 'email',
            dataIndex: 'email'
        }, {
            title: '状态',
            key: 'status',
            dataIndex: 'status_info'
        }, {
            title: '操作',
            key: 'action',
            render: function render(text, record, index) {
                return _react2.default.createElement(
                    'a',
                    { onClick: record.handleStatusChange.bind(null, record.id, record.status) },
                    record.status_info === '激活' ? '禁用' : '启用'
                );
            }
        }];
        var _props = this.props,
            users = _props.users,
            handleStatusChange = _props.handleStatusChange;
        var items = users.items,
            pagination = users.pagination,
            error = users.error,
            isFetching = users.isFetching;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var item = _step.value;

                item.handleStatusChange = handleStatusChange;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        var pager = Object.assign(_constants.PaginationConfig, {
            total: pagination.total,
            current: pagination.current_page,
            pageSize: pagination.per_page,
            onChange: function onChange(page, pageSize) {
                // 页码改变的回调，参数是改变后的页码及每页条数   
                _this.props.onChange(page);
            },
            onShowSizeChange: function onShowSizeChange(current, pageSize) {

            }
        });
        var tableConfig = {
            columns: columns,
            locale: { emptyText: error && !error.ok ? '\u7F51\u7EDC\u9519\u8BEF\uFF1A' + error.statusText : '暂无数据' },
            dataSource: items,
            loading: isFetching,
            pagination: pager,
            rowKey: function rowKey(record) {
                return record.id;
            }
        };
        return _react2.default.createElement(_table2.default, tableConfig);
    }
});

exports.default = UserList;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/user_list.js
// module id = 1323
// module chunks = 0